/**
 * Query-string key carrying a shared View.
 *
 * Lives in the domain rather than beside the hook that reads it, because the
 * route loader that prefetches a linked View has to know the key too — and a
 * loader importing a constant out of a component tree inverts the layering.
 */
export const VIEW_SEARCH_PARAM = "view";
